import React from 'react';
import CashierSalesContent from './CashierSalesContent';

const CashierSales = () => <CashierSalesContent />;

export default CashierSales;
